import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { IconModule } from '../icon/icon.module';
import { format } from 'date-fns/format';
import { DialogModule } from 'primeng/dialog';
import { DatepickerDefaultComponent } from 'src/components/datepicker/datepicker-default.component';
import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'app-input-date',
  templateUrl: './input-date.component.html',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    DialogModule,
    IconModule,
    DatepickerDefaultComponent,
    ButtonComponent,
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: InputDateComponent,
      multi: true,
    },
  ],
})
export class InputDateComponent implements ControlValueAccessor {
  @Input()
  resetValue: any = '';

  @Input()
  label?: string;

  @Input()
  labelTemplate?: TemplateRef<any>;

  @Input()
  placeholder: string = '';

  @Input()
  selectionMode: 'single' | 'range' = 'single';

  @Input()
  dateFormat: string = 'MM/dd/yyyy';

  @Input()
  styleClass: string = '';

  @Input()
  prefixStyleClass: string = '';

  @Input()
  inputStyleClass: string = '';

  @Output()
  selected = new EventEmitter<void>();

  @Input()
  minDate?: Date | string;

  @Input()
  maxDate?: Date | string;

  @Input()
  set value(value: string | null | undefined) {
    this._value = value;
    this.onChange(value);
    this.onTouched();

    if (value) {
      if (this.selectionMode === 'single') {
        this.valueDatepicker = [new Date(value), new Date(value)];
      }
      if (this.selectionMode === 'range') {
        this.valueDatepicker = value.split(' - ').map((date) => new Date(date));
      }
      this._setValueDisplayed();
    }

    if (!value) {
      this.valueDatepicker = [];
      this._setValueDisplayed();
    }
  }
  get value(): any {
    return this._value;
  }

  @Input()
  default?: (string | Date)[];

  @Input()
  disabled: boolean = false;

  private _value: any = '';
  private onChange: any = () => {};
  private onTouched: any = () => {};

  valueDatepicker: Date[] = [];
  valueDisplayed: any = '';
  calendarVisible: boolean = false;

  constructor() {
    if (this.resetValue) this.writeValue(this.resetValue);
  }

  get _minDate() {
    if (typeof this.minDate === 'string') return new Date(this.minDate);
    return this.minDate;
  }

  get _maxDate() {
    if (typeof this.maxDate === 'string') return new Date(this.maxDate);
    return this.maxDate;
  }

  showCalendar() {
    this.calendarVisible = true;
  }

  hideCalendar() {
    this.calendarVisible = false;
  }

  handleSelected() {
    // if (this.selectionMode === 'single') {
    //   this.writeValue(this.valueDatepicker[1]);
    // }
    // if (this.selectionMode === 'range') {
    //   const [start, end] = this.valueDatepicker;
    //   this.writeValue(
    //     `${format(new Date(start), this.dateFormat)} - ${format(new Date(end ?? ''), this.dateFormat)}`,
    //   );
    // }
    // this.hideCalendar()
  }

  applySelected() {
    if (this.selectionMode === 'single') {
      this.writeValue(this.valueDatepicker[1]);
    }

    if (this.selectionMode === 'range') {
      const [start, end] = this.valueDatepicker;
      this.writeValue(
        `${format(new Date(start), this.dateFormat)} - ${format(new Date(end ?? ''), this.dateFormat)}`,
      );
    }

    this.hideCalendar();
  }

  writeValue(value: any): void {
    this.value = value;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onCalendarHidden() {
    // if (
    //   this.selectionMode === 'range' &&
    //   Array.isArray(this.value) &&
    //   this.value.some((date) => date === null)
    // ) {
    //   this.writeValue(this.resetValue)
    // }
  }

  resetSelected() {
    this.writeValue(this.resetValue);
  }

  private _setValueDisplayed() {
    if (!this.valueDatepicker.length) {
      this.valueDisplayed = '';
      return;
    }

    if (this.selectionMode === 'range') {
      const [start, end] = this.valueDatepicker;
      this.valueDisplayed = `${format(new Date(start), this.dateFormat)} - ${format(
        new Date(end ?? start),
        this.dateFormat,
      )}`;
      return;
    }

    this.valueDisplayed = format(new Date(this.valueDatepicker[0]), this.dateFormat);
  }
}
